import { isEmpty, isNil } from 'ramda'

export const isEmptyOrNil = (value: any) => isEmpty(value) || isNil(value)
